// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
// import * as React from "react";
import {
  IUser,
  IUserAddRequest,
  useGetUserTypeList,
  useUpdateUser,
  useUserAdd,
  useGetAllMerchantList,
  useGetAllRoleList,
  useAuthorization,
  useGetMerchantsWithParentMerchant,
  useGetPosTypeList,
  useGetUserList,
  useSendApiUserCredentials,
  ISendApiUserCredentialsRequest
} from "../../../hooks";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Box,
  FormControl,
  Autocomplete,
  TextField,
  useTheme,
  useMediaQuery,
  fabClasses,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  Switch,
  Divider,
  RadioGroup,
  InputAdornment,
  IconButton,
  Typography
} from "@mui/material";
import { Stack } from "@mui/system";
import { useEffect, useMemo, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button, Loading, ApiCredentialsModal } from "../../atoms";
import {
  InputControl,
  RadioButtonsControl,
  CheckboxesControl,
  FormatInputControl,
  SwitchControl,
} from "../../molecules";
import { addUserFormSchema, UserAddFormValuesType } from "../_formTypes";
import { useLocation, useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { useUserInfo } from "../../../store/User.state";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import FormLabel from "@mui/material/FormLabel";
import { ControlCameraOutlined } from "@mui/icons-material";

export const UserAddForm = () => {
  const theme = useTheme();
  const { showCreate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const [userInfo] = useUserInfo();
  const user = useLocation().state as unknown as IUser | undefined;
  const setSnackbar = useSetSnackBar();
  const { mutate: getUserList, isUserLoading } = useGetUserList();
  const { data: rawRoles, isLoading: isRoleLoading } = useGetAllRoleList();
  // const { data: rawMerchantList,isLoading: isMerchantListLoading } = useGetAllMerchantList("ACTIVE");
  const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant("ACTIVE");
  const { data: userTypes, isLoading: isUserTypeLoading } = useGetUserTypeList({});
  const { mutate: userAdd, isLoading: isUserAddLoading } = useUserAdd();
  const { mutate: sendApiUserCredentials, isLoading: isSendApiUserCredentialsLoading } = useSendApiUserCredentials();
  const { data: rawPosTypes, isLoading: isPosTypeLoading } = useGetPosTypeList(
    {}
  );

  const { mutate: userUpdate, isLoading: isUserUpdateLoading } =
    useUpdateUser();
  const { handleSubmit, control, reset, setValue, watch, getValues } =
    useForm<UserAddFormValuesType>({
      resolver: zodResolver(addUserFormSchema),
    });

  const [selectedMerchant, setSelectedMerchant] = useState(
    user
      ? Number(userInfo.merchantId) !== 0
        ? { label: userInfo.merchantName, value: Number(userInfo.merchantId) }
        : null
      : null
  );
  const [userStatus, setUserStatus] = useState("");

  const posTypes = useMemo(() => {
    return [{ label: 'CepPOS işlem yetkisi', value: 'cepPos' }];
  }, [rawPosTypes?.data]);

  const userType = watch("userType");
  const prevUserType = useRef(userType);
  const fullName = watch("fullName");
  useEffect(() => {
    if (prevUserType.current !== userType && prevUserType.current !== undefined) {
      setValue("roleIds", {});
    }
    prevUserType.current = userType; // Güncel userType değerini referansa atıyoruz
  }, [userType, setValue]);

  useEffect(() => {
    if (!!user && JSON.stringify(user) !== "{}") {
      const tempRoleIds = user?.roles?.reduce(
        (acc, curr) => ((acc[curr?.key] = true), acc),
        {}
      );
      setSelectedMerchant({
        label: user?.merchantName || "",
        value: user?.merchantId,
      });
      setSelectedApiUser({ label: '', value: user?.parentUserId });
      setSelectedMerchantInputOBJ({ merchantId: user?.merchantId, isMerchantChanged: true });
      setApiUserListActive(user?.isCepPOSActive ?? false);
      setIsGoldBindingActive(user?.isGoldBindingActive ?? false);
      setIsSoftPOSRefundAuthActive(user?.isSoftPOSRefundAuthActive ?? false);
      setIsInternalUser(user?.isInternalUser ?? false);
      triggerUserList();
      setUserStatus(user.status);
      reset(
        {
          fullName: user?.fullName,
          email: user?.email,
          phoneNumber: user.phoneNumber,
          merchant: { label: user?.merchantName, value: user?.merchantId },
          // userType: `${user.userType}`,
          userType: user ? Number(user.userType) : 0,
          roleIds: tempRoleIds,
          status: user.status,
        },
        {
          keepIsValid: true,
        }
      );
    }
  }, [reset, setValue, user]);


  const merchantList = useMemo(() => {
    return rawMerchantList?.data?.map(
      (rawPosType: { merchantName: string; merchantId: number }) => {
        return {
          label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
          value: rawPosType.merchantId,
        };
      }
    );
  }, [rawMerchantList?.data]);



  const roleList = useMemo(() => {
    return rawRoles?.data
      ?.filter((rawRole) => rawRole.userType === userType)
      .filter(
        (item) =>
          (item.userType === 2 && item.order >= userInfo?.order) ||
          item.userType !== 2
      )
      .map((rawRole: { name: string; id: number; userType: number }) => {
        return {
          label: rawRole.name,
          value: `${rawRole.id}`,
          userType: rawRole?.userType,
        };
      });
  }, [rawRoles?.data, userType]);



  const userTypeList = useMemo(() => {
    if (userInfo.merchantId != 0) {
      return userTypes?.data?.filter((userType: { key: string; value: string }) => Number(userType.value) !== 1)
        .map((userType: { key: string; value: string }) => {
          return {
            label: userType.key,
            value: Number(userType.value),
          };
        });
    } else {
      return userTypes?.data?.map((userType: { key: string; value: string }) => {
        return {
          label: userType.key,
          value: Number(userType.value),
        };
      });
    }
  }, [userTypes?.data, userInfo?.merchantId]);



  const merchantId = watch('merchant')

  const onSubmit = ({
    email,
    fullName,
    phoneNumber,
    merchant,
    roleIds,
    userType,
    status,

  }: UserAddFormValuesType) => {

    let validRoleIds = roleList
      .filter(role => role.userType === userType)
      .map(role => role.value); // ekledin
    const tempRoleIds: Array<number> = [];

    for (const [key, value] of Object.entries(roleIds)) {
      if (value) {
        tempRoleIds.push(+key);
      }
    }

    const isCepPOSSelected = isApiUserListActive ?? false;


    const req: IUserAddRequest = {
      fullName: fullName,
      username: email,
      email: email,
      phoneNumber: phoneNumber || "",
      userType: Number(userType),
      roleIds: tempRoleIds,
      // merchantId: Number(selectedMerchant?.value) || 0,
      merchantId: merchantId || 0,
      status: status,
      isCepPOSActive: isCepPOSSelected,
      parentUserId: isCepPOSSelected ? selectedApiUser?.value ?? 0 : 0,
      isGoldBindingActive: isGoldBindingActive,
      isInternalUser: isInternalUser,
      isSoftPOSRefundAuthActive: isSoftPOSRefundAuthActive
    };

    if (!!user && Number(user?.id) > 0) {
      userUpdate(
        {
          ...req,
          id: user.id,
          systemPassword: false,
          memberId: 1,
        },
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              localStorage.setItem("fromEditPage", "true");
              navigate("/user-management/user-listing");
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          },
        }
      );
    } else {
      userAdd(req, {
        onSuccess: (data) => {
          if (data.isSuccess) {
            navigate("/user-management/user-listing");
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      });
    }
  };

  const [isDisabled, setIsDisabled] = useState(Number(userType) === 1);

  useEffect(() => {
    setIsDisabled(Number(userType) === 1);
    if (isDisabled) {
      setSelectedMerchant(null);
      setValue("merchant", 0);
    }
  }, [userType, isDisabled]);

  const handleBack = () => navigate("/user-management/user-listing");

  useEffect(() => {
    if (user?.id && !isDisabled && selectedMerchant) {
      setValue("merchant", selectedMerchant.value);
    }
  }, [user, isDisabled, selectedMerchant, setValue]);

  const hasLoading = isRoleLoading || isMerchantListLoading || isUserTypeLoading || isUserAddLoading || isUserUpdateLoading || isSendApiUserCredentialsLoading;

  const [selectedApiUser, setSelectedApiUser] = useState(null);
  const [apiUserList, setApiUserList] = useState([]);
  const [isApiUserListActive, setApiUserListActive] = useState(false);
  const [isGoldBindingActive, setIsGoldBindingActive] = useState(false);
  const [isSoftPOSRefundAuthActive, setIsSoftPOSRefundAuthActive] = useState(false);
  const [isInternalUser, setIsInternalUser] = useState(false);
  const [selectedMerchantInputOBJ, setSelectedMerchantInputOBJ] = useState({
    merchantId: user ? (user?.merchantId ?? 0) : 0,
    isMerchantChanged: false
  });

  useEffect(() => {

    triggerUserList();

  }, [selectedMerchantInputOBJ]);

  const handlePOSTypeChange = (checked: boolean, value: string) => {

    // if ((checked && apiUserList.length <= 0) || selectedMerchantInputOBJ.isMerchantChanged) {
    if (checked) {
      triggerUserList();
    }

    setApiUserListActive(checked);
  };

  const triggerUserList = () => {
    setApiUserList([]);

    if (!selectedMerchantInputOBJ?.merchantId) {
      return;
    }

    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: selectedMerchantInputOBJ?.merchantId,
      userTypeDesc: 'Api',
      status: "ACTIVE"
    };

    getUserList(requestPayload, {
      onSuccess: function (result) {
        const selectList = result?.data?.result?.flatMap((item) => { return { value: item.id, label: `${item.fullName} (${item.email})` } });
        setApiUserList(selectList ?? []);
        const findSelected = selectList.find(x => x.value === (user?.parentUserId ?? 0));
        if (findSelected) {
          setSelectedApiUser(findSelected);
        } else {
          setSelectedApiUser({ label: '', value: 0 })
        }
      }
    })
  }

  const [isApiModalOpen, setIsApiModalOpen] = useState(false);
  const [apiMerchant, setApiMerchant] = useState(null);
  const [apiEmail, setApiEmail] = useState("");
  const [apiPassword, setApiPassword] = useState("");
  const [apiUserDetail, setApiUserDetail] = useState(null);
  const [notificationType, setNotificationType] = useState('none');
  const [notificationEmail, setNotificationEmail] = useState('');
  const [notificationPhone, setNotificationPhone] = useState('');


  const handleApiModalOpen = () => setIsApiModalOpen(true);
  const handleApiModalClose = () => {
    setIsApiModalOpen(false);
    setApiMerchant(null);
    setApiEmail("");
    setApiPassword("");
    setNotificationType('none');
    setNotificationEmail('');
    setNotificationPhone('');
  };

  const handleApiModalSubmit = () => {

    const req: IUserAddRequest = {
      fullName: "",
      username: "",
      email: "",
      phoneNumber: "",
      userType: 3,
      roleIds: [],
      merchantId: apiMerchant?.value || 0,
      status: "ACTIVE"
    };

    userAdd(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setApiEmail(data?.data?.email);
          setApiPassword(data?.data?.password);
          setApiUserDetail(data?.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const handleSendUserInformation = () => {

    let request: ISendApiUserCredentialsRequest = {
      email: notificationEmail,
      notificationType: notificationType,
      phoneNumber: notificationPhone,
      password: apiPassword,
      userId: apiUserDetail?.id,
      username: apiEmail
    }

    sendApiUserCredentials(request, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          handleApiModalClose();
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: "Kullanıcı bilgileri başarıyla gönderildi!",
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      }
    })
  }

  return (
    <>
      <ApiCredentialsModal isOpen={isApiModalOpen}
        onClose={handleApiModalClose}
        onSubmit={handleApiModalSubmit}
        apiMerchant={apiMerchant}
        setApiMerchant={setApiMerchant}
        apiEmail={apiEmail}
        apiPassword={apiPassword}
        merchantList={merchantList}
        notificationType={notificationType}
        setNotificationType={setNotificationType}
        notificationEmail={notificationEmail}
        setNotificationEmail={setNotificationEmail}
        notificationPhone={notificationPhone}
        setNotificationPhone={setNotificationPhone}
        handleSendUserInformation={handleSendUserInformation}
      />
      {hasLoading && <Loading />}
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <Stack spacing={isDesktop ? 4 : 2}>
            <Stack
              width={isDesktop ? 1210 : "auto"}
              spacing={3}
              direction={isDesktop ? "row" : "column"}
            >
              <InputControl
                sx={{ flex: 1 }}
                label="Adı Soyadı"
                defaultValue=""
                control={control}
                id="fullName"
                stringOnly={true}
              />
              <InputControl
                sx={{ flex: 1 }}
                label="Kullanıcı Adı"
                defaultValue=""
                control={control}
                id="email"
                isDisabled={!!user && Number(user?.id) > 0}
              />
              <Button onClick={handleApiModalOpen} sx={{ mx: 2 }} text={"Api Bilgileri Oluştur"} />
            </Stack>
            <Stack width={isDesktop ? '100%' : "auto"} spacing={3} direction="row">
              <Stack width={isDesktop ? 388 : "auto"} spacing={3} direction="row">
                <FormatInputControl
                  sx={{ flex: 1 }}
                  defaultValue=""
                  label="Telefon Numarası"
                  control={control}
                  id="phoneNumber"
                  allowEmptyFormatting
                  mask="_"
                  format="0(###) ### ## ##"
                />
              </Stack>
              <Stack width={isDesktop ? 800 : 'auto'} spacing={3} direction="row">
                {posTypes && (
                  <CheckboxesControl
                    row
                    isCheckboxDisabled={selectedMerchantInputOBJ.merchantId <= 0}
                    id="cepPOSToggle"
                    control={control}
                    items={posTypes}
                    isCheckboxChecked={isApiUserListActive}
                    sx={{ width: isDesktop ? '50%' : 'auto' }}
                    changeCallback={handlePOSTypeChange}
                  />
                )}

                <CheckboxesControl
                  row
                  id="isGoldy"
                  control={control}
                  isCheckboxChecked={isGoldBindingActive}
                  sx={{ width: isDesktop ? '50%' : 'auto' }}
                  items={[{ label: 'Altın Bağlantı Yetkisi', value: 'isGoldBindingActive' }]}
                  changeCallback={(checked: boolean, value: string) => {
                    setIsGoldBindingActive(checked);
                  }}
                />

                <CheckboxesControl
                  row
                  id="isSoft"
                  control={control}
                  isCheckboxChecked={isSoftPOSRefundAuthActive}
                  sx={{ width: isDesktop ? '50%' : 'auto' }}
                  items={[{ label: 'İptal ve İade Yetkisi', value: 'isSoftPOSRefundAuthActive' }]}
                  changeCallback={(checked: boolean, value: string) => {
                    setIsSoftPOSRefundAuthActive(checked);
                  }}
                />

              </Stack>

            </Stack>
            <Stack width={isDesktop ? 800 : "auto"} >
              <FormControl sx={{ width: "100%" }}>
                {(selectedMerchantInputOBJ.merchantId > 0 && isApiUserListActive) && (
                  <Controller
                    row
                    control={control}
                    name="parentUserId"
                    render={(fieldState) => {
                      return (
                        <>
                          <Autocomplete
                            onChange={(event, selectedValue) => {
                              setValue(
                                "parentUserId",
                                selectedValue?.value || 0
                              );
                              setSelectedApiUser(selectedValue ?? { label: '', value: 0 });
                            }}
                            id="parentUserId"
                            options={apiUserList}
                            value={selectedApiUser ?? 0}
                            getOptionLabel={(option: {
                              label: string;
                              value: number;
                            }) => option.label}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Api Kullanıcısı"
                                error={fieldState.invalid}
                              />
                            )}
                          />
                        </>
                      );
                    }}
                  />
                )}
              </FormControl>
            </Stack>
            <Box flex={1}>
              {user?.id ? (
                <Controller
                  name="status"
                  control={control}
                  defaultValue={user?.status || "ACTIVE"}
                  render={({ field: { onChange, value } }) => (
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Kullanıcı Durumu</FormLabel>
                      <RadioGroup
                        aria-label="status"
                        name="status"
                        value={value}
                        onChange={onChange}
                      >
                        <FormControlLabel
                          value="ACTIVE"
                          control={<Radio />}
                          label="Aktif"
                        />
                        <FormControlLabel
                          value="BLOCKED"
                          control={<Radio />}
                          label="Blokeli"
                        />
                      </RadioGroup>
                    </FormControl>
                  )}
                />
              ) : null}
            </Box>
          </Stack>

          <Stack spacing={3}>
            <Stack
              width={isDesktop ? 800 : "auto"}
              direction={isDesktop ? "row" : "column"}
              spacing={3}
            >
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                {merchantList && (
                  <Controller
                    control={control}
                    name="merchant"
                    render={({ field, fieldState }) => {
                      return (
                        <>
                          <Autocomplete
                            value={merchantList.find(merchant => merchant.value === field.value) || null}
                            onChange={(event, selectedValue) => {
                              if (!isDisabled) {
                                // // setSelectedMerchant(selectedValue);
                                // setValue("merchant", selectedValue?.value || 0);
                                field.onChange(selectedValue?.value || 0);
                                setSelectedMerchantInputOBJ({
                                  merchantId: selectedValue?.value || 0,
                                  isMerchantChanged: true
                                });
                              }
                            }}
                            id="merchant"
                            options={merchantList}
                            getOptionLabel={(option: {
                              label: string;
                              value: number;
                            }) => option.label}
                            disabled={isDisabled}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Üye İşyeri"
                                error={fieldState.invalid}
                              />
                            )}
                          />
                        </>
                      );
                    }}
                  />
                )}
              </FormControl>

              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                {userTypeList && (
                  <Controller
                    control={control}
                    name="userType"
                    render={({ field: { onChange, value }, fieldState }) => {
                      const selectedUserType = userTypeList.find(
                        (option) => option.value === value
                      );

                      return (
                        <Autocomplete
                          id="userType"
                          options={userTypeList}
                          getOptionSelected={(option, value) =>
                            option.value === value
                          }
                          getOptionLabel={(option) => option.label}
                          value={selectedUserType || null}
                          onChange={(_, newValue) => {
                            onChange(newValue ? newValue.value : "");
                            setValue("roleIds", {}); // ekledim
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={fieldState.invalid}
                              label="Kullanıcı Tipi"
                            />
                          )}
                        />
                      );
                    }}
                  />
                )}
              </FormControl>

              <CheckboxesControl
                  row
                  id="IsInternal"
                  control={control}
                  isCheckboxChecked={isInternalUser}
                  sx={{ width: isDesktop ? '50%' : 'auto' }}
                  items={[{ label: 'İç Kullanıcı', value: 'isInternalUser' }]}
                  changeCallback={(checked: boolean, value: string) => {
                    setIsInternalUser(checked);
                  }}
                />

            </Stack>
            <Stack width={isDesktop ? 800 : "auto"} direction="row">
              {isDesktop && <FormControl sx={{ width: "50%" }} />}
              <Box flex={1}>
                {userType ? (
                  <CheckboxesControl
                    row={!isDesktop}
                    title="Kullanıcı Rolü"
                    control={control}
                    id="roleIds"
                    items={roleList}
                  />
                ) : null}
              </Box>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          borderTop="1px solid #E6E9ED"
          py={2}
          direction="row"
          justifyContent="flex-end"
        >
          {!!showCreate && (
            <Button
              onClick={handleSubmit(onSubmit)}
              variant="contained"
              text={!!user && Number(user?.id) > 0 ? "Güncelle" : "Kaydet"}
            />
          )}
          <Button onClick={handleBack} sx={{ mx: 2 }} text={"Iptal"} />
        </Stack>
      </Stack>

    </>
  );
};